(() => {
  const run = () => {
    if (!document.body.classList.contains("template-index")) return;

    const header = document.querySelector("header-component#header-component");
    if (!header) return;

    // force transparent mode even if theme didn't set it yet
    if (!header.hasAttribute("transparent")) {
      header.setAttribute("transparent", "always");
    }

    // these two vars are what paints the underlay gradient
    header.style.setProperty("--color-scheme-top-row", "rgba(0,0,0,0)", "important");
    header.style.setProperty("--color-scheme-bottom-row", "rgba(0,0,0,0)", "important");

    // kill underlays (they are inside the component)
    const closed = header.querySelector(".header__underlay-closed");
    const open = header.querySelector(".header__underlay-open");
    if (closed) {
      closed.style.setProperty("background", "transparent", "important");
      closed.style.setProperty("height", "0px", "important");
    }
    if (open) {
      open.style.setProperty("background", "transparent", "important");
      open.style.setProperty("height", "0px", "important");
    }
  };

  // run multiple times because header.js/hydration updates after load
  const schedule = () => [0, 50, 150, 300, 600, 1200].forEach(t => setTimeout(run, t));

  document.addEventListener("DOMContentLoaded", schedule);
  window.addEventListener("load", schedule);

  // watch for theme re-hydration updates
  const mo = new MutationObserver(() => run());
  mo.observe(document.documentElement, { subtree: true, childList: true, attributes: true });

  // some themes update on scroll
  window.addEventListener("scroll", () => run(), { passive: true });
})();
